// extracted by mini-css-extract-plugin
module.exports = {"header":"_3Fw-q","removeButton":"_2DmeB"};